import React from 'react';
import { Tag as AntTag } from 'antd';

import 'antComponentsStyle';
import './styles.scss';

const typeColors = {
    info: 'rgb(4, 123, 248)',
    success: 'rgb(133, 199, 81)',
    alert: 'rgb(230, 82, 82)',
}

const Tag = ({type, text}) => <AntTag color={typeColors[type] || null}>{text}</AntTag>

export default Tag
